import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { KioskService } from "src/app/core/services/kiosk.service";

@Component({
	selector: "app-kiosk-menu-categories",
	templateUrl: "./kiosk-menu-categories.component.html",
	styleUrls: ["../../kiosk.styles.scss"],
})
export class KioskMenuCategoriesComponent implements OnInit {
	@Output() canvasKeySelectedEmitter = new EventEmitter<number>();
	timestamp: number;

	constructor(public kioskService: KioskService) {}

	ngOnInit(): void {
		this.timestamp = new Date().valueOf();
	}
	trigger(key) {
		console.log(key);
	}
}
